var productTypeIcons = {
    'BusinessAuto': 'fa fa-car',
    'BusinessOwners': 'fa fa-universal-access',
    'CommercialPackage': 'fa fa-universal-access',
    'Guidance': 'fa fa-universal-access',
    'Homeowners': 'fa fa-home',
    'PersonalAuto': 'fa fa-car',
    'QuickQuote': 'fa fa-car',
    'WorkersComp': 'fa fa-cubes'
};

var lobIcons = {
    'BusinessAuto': 'fa fa-truck',
    'BusinessOwners': 'fa fa-universal-access',
    'CommercialPackage': 'fa fa-universal-access',
    'CommercialProperty': 'fa fa-industry',
    'GeneralLiability': 'fa fa-legal',
    'Homeowners': 'fa fa-home',
    'InlandMarine': 'fa fa-ship',
    'PersonalAuto': 'fa fa-car',
    'WorkersComp': 'fa fa-cubes'
};

var productCodeImages = {
    'BusinessAuto': 'product_commauto',
    'BusinessOwners': 'product_businessowner',
    'CommercialPackage': 'product_businessowner',
    'Guidance': 'product_guidance',
    'Homeowners': 'product_homeowners',
    'PersonalAuto': 'product_personalauto',
    'QuickQuote': 'product_quickquote',
    'WorkersComp': 'product_workerscomp'
};
var STOCK_PHOTO_URI = './styles/images/common/stockphotos/';

export default {
    getProductCodeIcon: function getProductCodeIcon(productCode) {
        return productTypeIcons[productCode];
    },
    getLOBIcon: function getLOBIcon(lobCode) {
        return lobIcons[lobCode];
    },
    getProductCodeImage: function getProductCodeImage(productCode) {
        var image = productCodeImages[productCode];
        return '' + STOCK_PHOTO_URI + image + '.svg';
    }
};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/api/gw-portals-util-js/ProductMediaMapUtil.js
// module id = 259
// module chunks = 0